var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 372.56,
    viewBox: "0 0 500 372.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No_data-rafiki",
    "data-name": "No data-rafiki",
    transform: "translate(0 -55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7782",
    "data-name": "Rectangle 7782",
    width: 500,
    height: 0.25,
    transform: "translate(0 382.4)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7783",
    "data-name": "Rectangle 7783",
    width: 33.12,
    height: 0.25,
    transform: "translate(416.78 398.49)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7784",
    "data-name": "Rectangle 7784",
    width: 8.69,
    height: 0.25,
    transform: "translate(322.53 401.21)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7785",
    "data-name": "Rectangle 7785",
    width: 19.19,
    height: 0.25,
    transform: "translate(396.59 389.21)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7786",
    "data-name": "Rectangle 7786",
    width: 43.19,
    height: 0.25,
    transform: "translate(52.46 390.89)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7787",
    "data-name": "Rectangle 7787",
    width: 6.33,
    height: 0.25,
    transform: "translate(104.56 390.89)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7788",
    "data-name": "Rectangle 7788",
    width: 93.68,
    height: 0.25,
    transform: "translate(131.47 395.11)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65857",
    "data-name": "Path 65857",
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65858",
    "data-name": "Path 65858",
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7789",
    "data-name": "Rectangle 7789",
    width: 137.78,
    height: 90.23,
    transform: "translate(427.47 174.06) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7790",
    "data-name": "Rectangle 7790",
    width: 140.02,
    height: 90.23,
    transform: "translate(425.5 174.06) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7791",
    "data-name": "Rectangle 7791",
    width: 137.78,
    height: 17.71,
    transform: "translate(427.47 191.76) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7792",
    "data-name": "Rectangle 7792",
    width: 140.02,
    height: 17.71,
    transform: "translate(418.51 191.76) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7793",
    "data-name": "Rectangle 7793",
    width: 78.46,
    height: 128.25,
    transform: "translate(419.62 89.72) rotate(90)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65859",
    "data-name": "Path 65859",
    d: "M390.7,168.17,374.32,89.72H348.76l16.38,78.45Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65860",
    "data-name": "Path 65860",
    d: "M416.9,162.32a.42.42,0,0,0,.42-.43V93.55a.42.42,0,0,0-.42-.42.41.41,0,0,0-.42.42v68.34a.42.42,0,0,0,.42.43Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65861",
    "data-name": "Path 65861",
    d: "M359.65,168.17,343.27,89.72H333.3l16.39,78.45Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7794",
    "data-name": "Rectangle 7794",
    width: 78.46,
    height: 0.75,
    transform: "translate(292.12 89.72) rotate(90)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65862",
    "data-name": "Path 65862",
    d: "M284.1,98.59H421.88l.54-6.59H284.64Z",
    fill: "#ebebeb",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65863",
    "data-name": "Path 65863",
    d: "M284.1,109.39H421.88l.54-6.58H284.64Z",
    fill: "#ebebeb",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65864",
    "data-name": "Path 65864",
    d: "M284.1,120.19H421.88l.54-6.58H284.64Z",
    fill: "#ebebeb",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65865",
    "data-name": "Path 65865",
    d: "M284.1,131H421.88l.54-6.59H284.64Z",
    fill: "#ebebeb",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65866",
    "data-name": "Path 65866",
    d: "M284.1,141.8H421.88l.54-6.59H284.64Z",
    fill: "#ebebeb",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65867",
    "data-name": "Path 65867",
    d: "M284.1,152.6H421.88l.54-6.59H284.64Z",
    fill: "#ebebeb",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7795",
    "data-name": "Rectangle 7795",
    width: 28.89,
    height: 5.7,
    transform: "translate(378.8 316.78)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7796",
    "data-name": "Rectangle 7796",
    width: 5.33,
    height: 131.07,
    transform: "translate(329.64 382.4) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7797",
    "data-name": "Rectangle 7797",
    width: 72.96,
    height: 5.7,
    transform: "translate(378.79 322.48) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7798",
    "data-name": "Rectangle 7798",
    width: 28.89,
    height: 5.7,
    transform: "translate(378.8 347.95)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7799",
    "data-name": "Rectangle 7799",
    width: 72.96,
    height: 5.7,
    transform: "translate(378.79 353.64) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7800",
    "data-name": "Rectangle 7800",
    width: 28.89,
    height: 5.7,
    transform: "translate(378.8 254.45)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7801",
    "data-name": "Rectangle 7801",
    width: 72.96,
    height: 5.7,
    transform: "translate(378.79 260.14) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7802",
    "data-name": "Rectangle 7802",
    width: 28.89,
    height: 5.7,
    transform: "translate(378.8 285.61)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7803",
    "data-name": "Rectangle 7803",
    width: 72.96,
    height: 5.7,
    transform: "translate(378.79 291.31) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7804",
    "data-name": "Rectangle 7804",
    width: 5.33,
    height: 131.07,
    transform: "translate(402.61 382.4) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7805",
    "data-name": "Rectangle 7805",
    width: 5.33,
    height: 131.07,
    transform: "translate(378.79 382.4) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7806",
    "data-name": "Rectangle 7806",
    width: 5.33,
    height: 131.07,
    transform: "translate(311.16 382.4) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7807",
    "data-name": "Rectangle 7807",
    width: 54.58,
    height: 105.89,
    transform: "translate(119.96 382.4) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65868",
    "data-name": "Path 65868",
    d: "M79.95,382.4H65.37V367.78H95.23Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7808",
    "data-name": "Rectangle 7808",
    width: 54.58,
    height: 105.89,
    transform: "translate(268.76 382.4) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7809",
    "data-name": "Rectangle 7809",
    width: 161.53,
    height: 100.86,
    transform: "translate(226.91 377.36) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65869",
    "data-name": "Path 65869",
    d: "M212.33,382.4H226.9V367.78H197.05Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7810",
    "data-name": "Rectangle 7810",
    width: 138.92,
    height: 25.24,
    transform: "translate(215.6 339.33) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7811",
    "data-name": "Rectangle 7811",
    width: 138.92,
    height: 25.24,
    transform: "translate(215.6 369.96) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65870",
    "data-name": "Path 65870",
    d: "M103.08,311.9h86.11a4.58,4.58,0,0,1,4.58,4.58v.31H98.51v-.31A4.58,4.58,0,0,1,103.08,311.9Z",
    transform: "translate(292.28 628.69) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7812",
    "data-name": "Rectangle 7812",
    width: 138.92,
    height: 25.24,
    transform: "translate(215.6 308.69) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65871",
    "data-name": "Path 65871",
    d: "M103.08,281.27h86.11a4.58,4.58,0,0,1,4.58,4.58v.31H98.51v-.31a4.58,4.58,0,0,1,4.57-4.58Z",
    transform: "translate(292.28 567.42) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65872",
    "data-name": "Path 65872",
    d: "M103.08,342.54h86.11a4.58,4.58,0,0,1,4.58,4.58v.31H98.51v-.31a4.58,4.58,0,0,1,4.57-4.58Z",
    transform: "translate(292.28 689.97) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7813",
    "data-name": "Rectangle 7813",
    width: 137.78,
    height: 90.23,
    transform: "translate(211.85 174.06) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7814",
    "data-name": "Rectangle 7814",
    width: 140.02,
    height: 90.23,
    transform: "translate(209.89 174.06) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7815",
    "data-name": "Rectangle 7815",
    width: 137.78,
    height: 17.71,
    transform: "translate(211.85 191.76) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7816",
    "data-name": "Rectangle 7816",
    width: 140.02,
    height: 17.71,
    transform: "translate(202.88 191.76) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7817",
    "data-name": "Rectangle 7817",
    width: 78.46,
    height: 128.25,
    transform: "translate(204 89.72) rotate(90)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65873",
    "data-name": "Path 65873",
    d: "M175.08,168.17,158.7,89.72H133.14l16.38,78.45Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65874",
    "data-name": "Path 65874",
    d: "M201.27,162.32a.42.42,0,0,0,.42-.43V93.55a.41.41,0,0,0-.42-.42.42.42,0,0,0-.42.42v68.34a.42.42,0,0,0,.42.43Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65875",
    "data-name": "Path 65875",
    d: "M144.03,168.17,127.65,89.72h-9.97l16.38,78.45Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7818",
    "data-name": "Rectangle 7818",
    width: 78.46,
    height: 0.75,
    transform: "translate(76.5 89.72) rotate(90)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65876",
    "data-name": "Path 65876",
    d: "M68.47,98.59H206.25l.54-6.59H69.01Z",
    fill: "#ebebeb",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65877",
    "data-name": "Path 65877",
    d: "M68.47,102.31H206.25l.54-6.59H69.01Z",
    fill: "#ebebeb",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65878",
    "data-name": "Path 65878",
    d: "M68.47,106.02H206.25l.54-6.58H69.01Z",
    fill: "#ebebeb",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65879",
    "data-name": "Path 65879",
    d: "M68.47,109.74H206.25l.54-6.59H69.01Z",
    fill: "#ebebeb",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65880",
    "data-name": "Path 65880",
    d: "M68.47,113.45H206.25l.54-6.58H69.01Z",
    fill: "#ebebeb",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65881",
    "data-name": "Path 65881",
    d: "M68.47,117.17H206.25l.54-6.59H69.01Z",
    fill: "#ebebeb",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7819",
    "data-name": "Rectangle 7819",
    width: 4.76,
    height: 53.09,
    transform: "translate(100.78 273.27) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7820",
    "data-name": "Rectangle 7820",
    width: 1.35,
    height: 53.09,
    transform: "translate(97.97 273.24) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7821",
    "data-name": "Rectangle 7821",
    width: 0.53,
    height: 53.09,
    transform: "translate(99.06 273.24) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65882",
    "data-name": "Path 65882",
    d: "M80.76,272.06H116a4.44,4.44,0,0,1-4.44,4.44H85.21a4.44,4.44,0,0,1-4.44-4.44h-.01Z",
    transform: "translate(196.79 548.57) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65883",
    "data-name": "Path 65883",
    d: "M89.84,253.14h0a1.38,1.38,0,0,0,1.37-1.37V217a1.37,1.37,0,0,0-1.37-1.37h0A1.37,1.37,0,0,0,88.46,217v34.81a1.38,1.38,0,0,0,1.38,1.33Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65884",
    "data-name": "Path 65884",
    d: "M77.07,232.8h42.65L114.81,203H81.98Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-1",
    cx: 193.89,
    cy: 11.32,
    rx: 193.89,
    ry: 11.32,
    transform: "translate(56.11 404.92)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window-no-data--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7822",
    "data-name": "Rectangle 7822",
    width: 1,
    height: 18.49,
    transform: "translate(103.123 202.431) rotate(-4.12)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7823",
    "data-name": "Rectangle 7823",
    width: 1,
    height: 6.96,
    transform: "translate(105.129 230.394) rotate(-4.12)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65885",
    "data-name": "Path 65885",
    d: "M337.71,315.16H123.55a9.65,9.65,0,0,1-9.44-8.81L103.59,160.22a8.1,8.1,0,0,1,8.17-8.8H325.92a9.65,9.65,0,0,1,9.44,8.8l10.52,146.13a8.11,8.11,0,0,1-8.17,8.81Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65886",
    "data-name": "Path 65886",
    d: "M338.53,315.16H124.37a9.65,9.65,0,0,1-9.44-8.81L104.41,160.22a8.1,8.1,0,0,1,8.17-8.8H326.74a9.65,9.65,0,0,1,9.44,8.8L346.7,306.35a8.1,8.1,0,0,1-8.17,8.81Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65887",
    "data-name": "Path 65887",
    d: "M338.53,315.16H124.37a9.65,9.65,0,0,1-9.44-8.81L104.41,160.22a8.1,8.1,0,0,1,8.17-8.8H326.74a9.65,9.65,0,0,1,9.44,8.8L346.7,306.35a8.1,8.1,0,0,1-8.17,8.81Z",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65888",
    "data-name": "Path 65888",
    d: "M327.06,155.82H112.18c-5.47.45-4.35,8.78,1.17,8.78H327.87c5.53,0,5.45-8.33-.09-8.78Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65889",
    "data-name": "Path 65889",
    d: "M118.48,160.22a1.85,1.85,0,0,1-1.88,2,2.2,2.2,0,0,1-2.16-2,1.85,1.85,0,0,1,1.87-2,2.2,2.2,0,0,1,2.17,2Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65890",
    "data-name": "Path 65890",
    d: "M125.35,160.22a1.85,1.85,0,0,1-1.88,2,2.2,2.2,0,0,1-2.16-2,1.85,1.85,0,0,1,1.87-2,2.2,2.2,0,0,1,2.17,2Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65891",
    "data-name": "Path 65891",
    d: "M132.21,160.22a1.85,1.85,0,0,1-1.87,2,2.19,2.19,0,0,1-2.16-2,1.84,1.84,0,0,1,1.87-2,2.2,2.2,0,0,1,2.16,2Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65892",
    "data-name": "Path 65892",
    d: "M332.85,300.58H128a3.49,3.49,0,0,1-3.42-3.2l-8.65-120.17a2.92,2.92,0,0,1,3-3.19h204.9a3.48,3.48,0,0,1,3.42,3.19l8.66,120.17a2.94,2.94,0,0,1-3.06,3.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65893",
    "data-name": "Path 65893",
    d: "M246.53,254.8l-3.34-46.32-10.1-6.08H205.28l3.78,52.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65894",
    "data-name": "Path 65894",
    d: "M246.53,255.28H209.06a.48.48,0,0,1-.49-.45l-3.77-52.4a.47.47,0,0,1,.13-.36.48.48,0,0,1,.35-.16h27.81a.55.55,0,0,1,.25.07l10.1,6.08a.48.48,0,0,1,.24.38L247,254.76a.46.46,0,0,1-.13.37.47.47,0,0,1-.34.15Zm-37-1H246l-3.28-45.55L233,202.88H205.8Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65895",
    "data-name": "Path 65895",
    d: "M243.19,208.48l-10.1-6.08,3.71,8.06Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65896",
    "data-name": "Path 65896",
    d: "M236.8,210.94a.49.49,0,0,1-.44-.28l-3.71-8.06a.482.482,0,0,1,.69-.62l10.1,6.08a.5.5,0,0,1,.24.48.49.49,0,0,1-.34.4l-6.4,2Zm-2.61-7.32,2.87,6.25,5-1.53Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65897",
    "data-name": "Path 65897",
    d: "M221,226a2,2,0,0,1-2,2.11,2.31,2.31,0,0,1-2.26-2.11,1.94,1.94,0,0,1,2-2.12A2.32,2.32,0,0,1,221,226Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65898",
    "data-name": "Path 65898",
    d: "M234.7,226a1.94,1.94,0,0,1-2,2.11,2.32,2.32,0,0,1-2.27-2.11,2,2,0,0,1,2-2.12A2.31,2.31,0,0,1,234.7,226Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65899",
    "data-name": "Path 65899",
    d: "M238.58,239.74a.49.49,0,0,1-.48-.45c-.25-3.41-5.59-6.18-11.9-6.18-4.19,0-7.95,1.25-9.81,3.25a3.74,3.74,0,0,0-1.14,2.86.5.5,0,0,1-1,.07,4.76,4.76,0,0,1,1.4-3.59c2-2.19,6.07-3.56,10.52-3.56,6.93,0,12.58,3.11,12.86,7.08a.48.48,0,0,1-.45.51Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65900",
    "data-name": "Path 65900",
    d: "M213.17,221.72a.51.51,0,0,1-.33-.13.49.49,0,0,1,0-.69l2.13-2.29a.49.49,0,0,1,.68,0,.48.48,0,0,1,0,.68l-2.13,2.29a.48.48,0,0,1-.35.14Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65901",
    "data-name": "Path 65901",
    d: "M237.58,221.72a.55.55,0,0,1-.33-.13l-2.45-2.29a.48.48,0,0,1,0-.69.49.49,0,0,1,.68,0l2.45,2.29a.48.48,0,0,1,0,.68.52.52,0,0,1-.35.14Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65902",
    "data-name": "Path 65902",
    d: "M202.26,265.15h2.26l3.26,4.34-.31-4.34h2.28l.56,7.84H208l-3.24-4.31.31,4.31h-2.28Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65903",
    "data-name": "Path 65903",
    d: "M211.33,269.07a3.8,3.8,0,0,1,.86-3,3.76,3.76,0,0,1,2.9-1.07,4.38,4.38,0,0,1,3.09,1.05,4.32,4.32,0,0,1,1.27,2.94,4.77,4.77,0,0,1-.3,2.25,3,3,0,0,1-1.24,1.37,4.16,4.16,0,0,1-2.14.49,5.249,5.249,0,0,1-2.23-.42,3.62,3.62,0,0,1-1.5-1.34,4.66,4.66,0,0,1-.71-2.27Zm2.43,0a2.73,2.73,0,0,0,.56,1.7,1.59,1.59,0,0,0,1.24.52,1.38,1.38,0,0,0,1.17-.51A2.75,2.75,0,0,0,217,269a2.57,2.57,0,0,0-.56-1.62,1.64,1.64,0,0,0-1.25-.51,1.38,1.38,0,0,0-1.14.52,2.53,2.53,0,0,0-.29,1.7Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65904",
    "data-name": "Path 65904",
    d: "M224.15,265.15h3.6a4.51,4.51,0,0,1,1.74.29,3.06,3.06,0,0,1,1.14.83,3.76,3.76,0,0,1,.71,1.25,6.3,6.3,0,0,1,.3,1.52,5.08,5.08,0,0,1-.15,1.95,2.8,2.8,0,0,1-.71,1.16,2.3,2.3,0,0,1-1,.62,5.6,5.6,0,0,1-1.43.22h-3.59Zm2.55,1.78.31,4.28h.59a2.45,2.45,0,0,0,1.07-.17,1,1,0,0,0,.46-.59,3.54,3.54,0,0,0,.08-1.36,2.72,2.72,0,0,0-.53-1.7,1.81,1.81,0,0,0-1.38-.46Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65905",
    "data-name": "Path 65905",
    d: "M237.45,271.69H234.7l-.29,1.3h-2.47l2.38-7.84H237l3.51,7.84h-2.54Zm-.63-1.69-1.06-2.82L235.1,270Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65906",
    "data-name": "Path 65906",
    d: "M239.37,265.15h7.36l.14,1.94H244.4l.42,5.9H242.4l-.42-5.9h-2.47Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65907",
    "data-name": "Path 65907",
    d: "M252.37,271.69h-2.75l-.29,1.3h-2.47l2.38-7.84h2.64l3.5,7.84h-2.53Zm-.63-1.69-1.07-2.82L250,270Z",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65908",
    "data-name": "Path 65908",
    d: "M353.69,173.08c.89-.45,2-1,2.94-1.57s2-1.12,3-1.72c1.95-1.21,3.93-2.4,5.8-3.72a76.942,76.942,0,0,0,10.52-8.66c.41-.38.77-.8,1.16-1.21l.57-.61.28-.3.14-.16h0c-.14.27,0,.19,0-.07a5.277,5.277,0,0,0,.15-1.09,30.6,30.6,0,0,0-.73-6.32c-.89-4.48-2.24-9.1-3.57-13.62l3.88-1.7a81.308,81.308,0,0,1,6.11,13.6,31.669,31.669,0,0,1,1.72,7.89,12,12,0,0,1-.08,2.51,7.71,7.71,0,0,1-1.22,3.29l-.17.23-.13.16-.15.19-.31.38-.62.75c-.41.49-.81,1-1.25,1.47A71.853,71.853,0,0,1,370.35,173a75.482,75.482,0,0,1-6.29,4.19c-1.07.65-2.16,1.27-3.27,1.88s-2.19,1.17-3.47,1.77Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65909",
    "data-name": "Path 65909",
    d: "M344.79,408.18a10.268,10.268,0,0,0,2.22-.3.22.22,0,0,0,.15-.16.21.21,0,0,0-.09-.2c-.29-.19-2.83-1.83-3.81-1.39a.68.68,0,0,0-.39.56,1.13,1.13,0,0,0,.33,1.05,2.35,2.35,0,0,0,1.59.44Zm1.65-.58c-1.45.29-2.55.24-3-.15a.77.77,0,0,1-.2-.71.3.3,0,0,1,.17-.25C343.94,406.26,345.41,407,346.44,407.6Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65910",
    "data-name": "Path 65910",
    d: "M347,407.88h.1a.21.21,0,0,0,.1-.17c0-.11,0-2.52-.92-3.32a1,1,0,0,0-.84-.27.69.69,0,0,0-.67.55c-.19,1,1.33,2.75,2.13,3.21a.18.18,0,0,0,.1,0Zm-1.43-3.39a.66.66,0,0,1,.44.17,4.53,4.53,0,0,1,.78,2.64c-.8-.64-1.75-2-1.63-2.57,0-.09.07-.21.32-.24Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65911",
    "data-name": "Path 65911",
    d: "M346.22,148.07c-1,5-3,15,.45,18.35,0,0-1.36,5-10.59,5-10.16,0-4.85-5-4.85-5,5.54-1.32,5.39-5.43,4.43-9.3Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65912",
    "data-name": "Path 65912",
    d: "M329.28,168.42c-1.59.22-.23-3.91.41-4.34,1.5-1,20.86-2.39,20.73,0-.08,1-.56,3-1.4,3.66S343.2,166.34,329.28,168.42Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65913",
    "data-name": "Path 65913",
    d: "M332.44,167c-1.27.43-1.15-3.73-.72-4.23,1-1.16,16.67-5.18,17.13-2.91.18,1,.27,3-.27,3.71S343.44,163.11,332.44,167Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65914",
    "data-name": "Path 65914",
    d: "M326.61,139.11a.4.4,0,0,1-.33-.15,3.18,3.18,0,0,0-2.59-1.23.39.39,0,0,1-.44-.35.4.4,0,0,1,.35-.43,3.91,3.91,0,0,1,3.29,1.51.4.4,0,0,1-.05.56.5.5,0,0,1-.23.09Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65915",
    "data-name": "Path 65915",
    d: "M324.67,144a17.907,17.907,0,0,1-2,4.53,2.9,2.9,0,0,0,2.44.21Z",
    fill: "#ff5652"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65916",
    "data-name": "Path 65916",
    d: "M325.16,142.79c.07.67-.24,1.25-.68,1.29s-.85-.46-.91-1.14.24-1.25.67-1.29S325.09,142.11,325.16,142.79Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65917",
    "data-name": "Path 65917",
    d: "M324.44,141.67l-1.66-.31S323.73,142.54,324.44,141.67Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65918",
    "data-name": "Path 65918",
    d: "M356.7,407.69h-8.38l.66-19.4h8.38Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65919",
    "data-name": "Path 65919",
    d: "M347.66,406.72h9.41a.66.66,0,0,1,.67.57l1.07,7.44a1.34,1.34,0,0,1-1.34,1.49c-3.28-.05-4.86-.25-9-.25-2.55,0-6.27.27-9.78.27s-3.71-3.48-2.24-3.79c6.56-1.42,7.6-3.36,9.81-5.22a2.21,2.21,0,0,1,1.4-.51Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38455",
    "data-name": "Group 38455",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65920",
    "data-name": "Path 65920",
    d: "M357.36,388.29h-8.38l-.34,10h8.38Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_65921",
    "data-name": "Path 65921",
    d: "M323.37,178a162.478,162.478,0,0,1-15.05-6.75,91.241,91.241,0,0,1-14.4-8.77,34.309,34.309,0,0,1-3.42-3.07c-.28-.3-.56-.58-.83-.93a11.32,11.32,0,0,1-.88-1.13,7.9,7.9,0,0,1-1.34-3.61,8.22,8.22,0,0,1,.49-3.62,10.64,10.64,0,0,1,1.41-2.6,18.13,18.13,0,0,1,3.39-3.52,42,42,0,0,1,7.3-4.67c1.24-.66,2.5-1.25,3.78-1.8s2.54-1.07,3.91-1.54l1.77,3.85c-4.36,2.75-8.88,5.78-12.2,9.16a13.859,13.859,0,0,0-1.95,2.49c-.48.79-.47,1.38-.39,1.33s0,0,.14.1l.4.43c.15.18.36.36.55.55a25.618,25.618,0,0,0,2.69,2.16,62.921,62.921,0,0,0,6.44,4c2.25,1.26,4.57,2.45,6.93,3.59,4.72,2.26,9.6,4.43,14.39,6.41Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65922",
    "data-name": "Path 65922",
    d: "M312,137.15l1.38-3L307.06,132s-2,5.91.37,8.63h0A6.05,6.05,0,0,0,312,137.15Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65923",
    "data-name": "Path 65923",
    d: "M313.35,127.66l-5.03-1.46-1.26,5.76,6.29,2.19Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65924",
    "data-name": "Path 65924",
    d: "M378.35,134.44l.73-7L372.6,129s-.1,6.58,3.33,7.62Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65925",
    "data-name": "Path 65925",
    d: "M375.96,122.51l-4.23,1.97.87,4.47,6.48-1.53Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65926",
    "data-name": "Path 65926",
    d: "M347.54,138.25c.31,8.31.61,11.82-3.14,16.47-5.65,7-15.92,5.55-18.7-2.5-2.5-7.24-2.58-19.61,5.18-23.69a11.34,11.34,0,0,1,16.66,9.72Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65927",
    "data-name": "Path 65927",
    d: "M343.92,154.71c8.16-3.53,13.52-11,11.26-22.58-2.17-11.11-9.67-12.21-12.77-9.91s-10.83-1.13-15.47,2.77c-8,6.77-.44,14,3.52,18.37C332.82,148.22,335.92,158.16,343.92,154.71Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65928",
    "data-name": "Path 65928",
    d: "M340.53,130.14a8.29,8.29,0,1,0,1.83-11.92,8.53,8.53,0,0,0-1.83,11.92Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65929",
    "data-name": "Path 65929",
    d: "M342.65,123c-1.17-6.7,5.16-11.86,13.64-9.37s4,10,2.25,16,2.83,11.72,4.73,7.15-1.3-6-1.3-6,9,2.33.64,12.48-15.93-1.06-13.88-7.67C350.39,130.28,343.76,129.33,342.65,123Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65930",
    "data-name": "Path 65930",
    d: "M334.18,125.53c-3.87-2-10.42-3.65-14.15,2.63-1.76,3-1.08,7-1.08,7l11.39.75Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65931",
    "data-name": "Path 65931",
    d: "M317.61,133.18h0a.26.26,0,0,1-.24-.27c0-.17.29-4.19,2.72-6.71,5.87-6.1,12.75-1,14.71.65a.25.25,0,0,1-.32.38c-1.89-1.62-8.47-6.47-14-.69-2.3,2.39-2.58,6.36-2.58,6.4a.25.25,0,0,1-.29.24Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65932",
    "data-name": "Path 65932",
    d: "M331.85,143a6.89,6.89,0,0,1-1.65,4.28c-1.38,1.62-3,.82-3.33-1-.33-1.61,0-4.4,1.74-5.37S331.87,141.18,331.85,143Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65933",
    "data-name": "Path 65933",
    d: "M330.05,219.12s.54,58.15,5.58,90.55c4.08,26.17,11.61,86.69,11.61,86.69h11.43s1.11-58.43-1-84.31c-5.23-65.5,8.28-77.75-2.62-92.93Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65934",
    "data-name": "Path 65934",
    d: "M330.05,219.12s.54,58.15,5.58,90.55c4.08,26.17,11.61,86.69,11.61,86.69h11.43s1.11-58.43-1-84.31c-5.23-65.5,8.28-77.75-2.62-92.93Z",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65935",
    "data-name": "Path 65935",
    d: "M336.06,245.5c4,17.55.81,45.19-1.38,57.36-2.32-18.48-3.49-42.43-4.07-60C332.68,239.52,334.64,239.3,336.06,245.5Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65936",
    "data-name": "Path 65936",
    d: "M345.68,396.58h14.55l.76-5.1-15.39-.52Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65937",
    "data-name": "Path 65937",
    d: "M349.83,170c1.37-2.72,8.73-4.43,12.75-4.42l3,13.36s-8,11.89-11.34,10.63C350.31,188.12,346.9,175.87,349.83,170Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65938",
    "data-name": "Path 65938",
    d: "M349.83,170c1.37-2.72,8.73-4.43,12.75-4.42l3,13.36s-8,11.89-11.34,10.63C350.31,188.12,346.9,175.87,349.83,170Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65939",
    "data-name": "Path 65939",
    d: "M341.35,393.31a.19.19,0,0,0,0-.19.2.2,0,0,0-.21-.11c-.42.07-4.12.65-4.62,1.71a.65.65,0,0,0,0,.63,1.1,1.1,0,0,0,.86.57c1.21.12,3-1.56,3.9-2.58Zm-4.44,1.54c.34-.56,2.26-1.08,3.72-1.35-1.32,1.34-2.48,2.09-3.16,2a.71.71,0,0,1-.56-.38.25.25,0,0,1,0-.25A.014.014,0,0,1,336.91,394.85Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65940",
    "data-name": "Path 65940",
    d: "M341.35,393.31a.19.19,0,0,0,0-.19c-.06-.07-1.54-1.78-2.91-1.87a1.44,1.44,0,0,0-1.09.37c-.41.37-.37.69-.27.89.43.86,3.09,1.16,4.16.93a.18.18,0,0,0,.11-.13Zm-3.91-1.26a.79.79,0,0,1,.16-.18,1,1,0,0,1,.79-.27,4.6,4.6,0,0,1,2.39,1.47c-1.19.1-3.11-.26-3.37-.78a.24.24,0,0,1,.03-.24Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65941",
    "data-name": "Path 65941",
    d: "M350.08,389.76l-7.66,3.41-3.41-7.11-4.46-9.3-.53-1.08,7.66-3.41.59,1.22,4.32,9.01Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65942",
    "data-name": "Path 65942",
    d: "M346.59,382.5l-7.58,3.56-4.46-9.3,7.72-3.27Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65943",
    "data-name": "Path 65943",
    d: "M321.07,219.12S296.6,280,303.23,308.6c6,25.89,32.5,74.92,32.5,74.92L346,378.38s-16.39-59.19-18.16-72.05c-3.46-25,18.77-60.33,18.77-87.21Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65944",
    "data-name": "Path 65944",
    d: "M321.07,219.12S296.6,280,303.23,308.6c6,25.89,32.5,74.92,32.5,74.92L346,378.38s-16.39-59.19-18.16-72.05c-3.46-25,18.77-60.33,18.77-87.21Z",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65945",
    "data-name": "Path 65945",
    d: "M341.06,392.1l7.6-5.53a.66.66,0,0,1,.88.06l5.25,5.39a1.35,1.35,0,0,1-.21,2c-2.69,1.88-4.08,2.66-7.42,5.09-2.06,1.5-6.16,4.81-9,6.88s-5-.63-4-1.74c4.48-5,5.42-8.1,6.12-10.91a2.17,2.17,0,0,1,.78-1.24Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65946",
    "data-name": "Path 65946",
    d: "M335.07,385.69l13.23-6.05-1.69-5.39-14.17,6.46Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65947",
    "data-name": "Path 65947",
    d: "M327.56,169.36c-1.09-2.84-10.65-6-15.45-7L310,178.08s7.84,11.26,11.27,10.33C325.33,187.31,329.92,175.45,327.56,169.36Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65948",
    "data-name": "Path 65948",
    d: "M327.56,169.36c-1.09-2.84-10.65-6-15.45-7L310,178.08s7.84,11.26,11.27,10.33C325.33,187.31,329.92,175.45,327.56,169.36Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65949",
    "data-name": "Path 65949",
    d: "M317.07,168.57s-4,1.4,4,50.55h34c-.57-13.84-.59-22.38,6-50.8a100.278,100.278,0,0,0-14.45-1.9,107.4,107.4,0,0,0-15.44,0A142.556,142.556,0,0,0,317.07,168.57Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65950",
    "data-name": "Path 65950",
    d: "M317.07,168.57s-4,1.4,4,50.55h34c-.57-13.84-.59-22.38,6-50.8a100.278,100.278,0,0,0-14.45-1.9,107.4,107.4,0,0,0-15.44,0A142.556,142.556,0,0,0,317.07,168.57Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65951",
    "data-name": "Path 65951",
    d: "M355.6,217.13l1.53,3c.12.24-.16.48-.55.48H320.9c-.31,0-.56-.15-.58-.35l-.31-3c0-.21.25-.39.58-.39H355a.61.61,0,0,1,.6.26Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65952",
    "data-name": "Path 65952",
    d: "M355.6,217.13l1.53,3c.12.24-.16.48-.55.48H320.9c-.31,0-.56-.15-.58-.35l-.31-3c0-.21.25-.39.58-.39H355a.61.61,0,0,1,.6.26Z",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65953",
    "data-name": "Path 65953",
    d: "M351,221h.92c.19,0,.33-.1.31-.21l-.43-4c0-.12-.17-.21-.35-.21h-.93c-.18,0-.32.09-.31.21l.43,4C350.63,220.88,350.79,221,351,221Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65954",
    "data-name": "Path 65954",
    d: "M328.61,221h.92c.18,0,.32-.1.31-.21l-.43-4c0-.12-.17-.21-.36-.21h-.92c-.19,0-.32.09-.31.21l.43,4C328.26,220.88,328.42,221,328.61,221Z",
    fill: "#263238"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFound);
export default __webpack_public_path__ + "static/media/noDataFound.240ca2c5618fddf9666209700d93a999.svg";
export { ForwardRef as ReactComponent };